var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledStarIcon = function SvgFilledStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.813 6.28-2.461 2.124.75 3.176a.897.897 0 0 1-1.34.975L7 10.855l-2.763 1.7a.897.897 0 0 1-1.339-.975l.753-3.176L1.19 6.281a.9.9 0 0 1 .51-1.578l3.226-.26L6.171 1.43a.895.895 0 0 1 1.655 0L9.07 4.443l3.227.26a.9.9 0 0 1 .512 1.578z"
  })));
};
export default SvgFilledStarIcon;